module.exports = __webpack_public_path__ + "img/ice_blue_shield.613b8464.png";